import { z } from 'zod';

export const LEELA_SQUARE_KINDS = ['NORMAL', 'SNAKE', 'LADDER'] as const;
export const LeelaSquareKind = z.enum(LEELA_SQUARE_KINDS);
export type LeelaSquareKind = z.infer<typeof LeelaSquareKind>;

export const LEELA_SESSION_STATUSES = ['ACTIVE', 'COMPLETED', 'ABANDONED'] as const;
export const LeelaSessionStatus = z.enum(LEELA_SESSION_STATUSES);
export type LeelaSessionStatus = z.infer<typeof LeelaSessionStatus>;

export const LEELA_MESSAGE_ROLES = ['USER', 'LILO'] as const;
export const LeelaMessageRole = z.enum(LEELA_MESSAGE_ROLES);
export type LeelaMessageRole = z.infer<typeof LeelaMessageRole>;

export const CreateLeelaSessionInput = z.object({
  question: z.string().trim().min(1).max(500),
});
export type CreateLeelaSessionInput = z.infer<typeof CreateLeelaSessionInput>;

export const PostLeelaMessageInput = z.object({
  text: z.string().trim().min(1).max(1000),
});
export type PostLeelaMessageInput = z.infer<typeof PostLeelaMessageInput>;

export const LeelaMessageDto = z.object({
  id: z.string(),
  role: LeelaMessageRole,
  text: z.string(),
  createdAt: z.string(),
});
export type LeelaMessageDto = z.infer<typeof LeelaMessageDto>;

export const LeelaTurnDto = z.object({
  id: z.string(),
  turnNumber: z.number().int(),
  diceRolls: z.array(z.number().int()),
  squareNumber: z.number().int(),
  redirectedFrom: z.number().int().nullable(),
  overshot: z.boolean(),
  liloMessage: z.string(),
  createdAt: z.string(),
  messages: z.array(LeelaMessageDto),
});
export type LeelaTurnDto = z.infer<typeof LeelaTurnDto>;

export const LeelaSessionListItemDto = z.object({
  id: z.string(),
  question: z.string(),
  status: LeelaSessionStatus,
  currentSquare: z.number().int(),
  startedAt: z.string(),
  completedAt: z.string().nullable(),
  /** Партия куплена целиком: броски и реплики внутри неё больше не тарифицируются. */
  paid: z.boolean(),
});
export type LeelaSessionListItemDto = z.infer<typeof LeelaSessionListItemDto>;

export const LeelaSessionDetailDto = LeelaSessionListItemDto.extend({
  turns: z.array(LeelaTurnDto),
});
export type LeelaSessionDetailDto = z.infer<typeof LeelaSessionDetailDto>;

/** Query-параметры `GET /leela/sessions` — курсорная пагинация (добавлено на eng-review: список сессий не ограничен по размеру, а терминальные сессии не удаляются). */
export const LeelaSessionListQuery = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type LeelaSessionListQuery = z.infer<typeof LeelaSessionListQuery>;

export const LeelaSessionListPageDto = z.object({
  items: z.array(LeelaSessionListItemDto),
  nextCursor: z.string().nullable(),
});
export type LeelaSessionListPageDto = z.infer<typeof LeelaSessionListPageDto>;

/** Ответ create/roll/messages — сессия + актуальный ход, чтобы клиент сразу знал новый статус. */
export const LeelaTurnResultDto = z.object({
  session: LeelaSessionListItemDto,
  turn: LeelaTurnDto,
});
export type LeelaTurnResultDto = z.infer<typeof LeelaTurnResultDto>;

/** Пользовательская часть биллинга «Лило». Цена и лимиты клиенту известны из констант этого же пакета, поэтому здесь только то, чего он вывести не может. */
export const LeelaBillingDto = z.object({
  trialRollsLeft: z.number().int().min(0),
});
export type LeelaBillingDto = z.infer<typeof LeelaBillingDto>;
